import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const ReadyToSave = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const fadeUpVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut" },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 1.1 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  const handleButtonBookConsultation = () => {
    navigate("/get-started");
  };

  return (
    <section
      ref={ref}
      className="flex items-center lg:min-h-screen overflow-hidden"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
        <div className="bg-[#007B83] bg-cover bg-center bg-no-repeat flex items-center justify-center px-6 md:px-12 lg:px-16 py-12 md:py-16 lg:py-0 lg:min-h-screen relative ready-save-bg">
          <div className="absolute inset-0 bg-[#007B83]/90 lg:bg-[#007B83]"></div>
          <motion.div
            className="relative z-10 max-w-lg space-y-4 sm:space-y-6 md:space-y-8"
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
          >
            <motion.h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-[#E3F3FA] to-[#FFFFFF] bg-clip-text text-transparent leading-tight"
              variants={fadeUpVariants}
            >
              {t("readyToSave.heading")}
            </motion.h1>

            <motion.p
              className="text-sm sm:text-base md:text-lg text-[#FFFFFF] leading-relaxed"
              variants={fadeUpVariants}
            >
              {t("readyToSave.description")}
            </motion.p>

            <motion.button
              className="btn-secondary text-sm sm:text-base"
              variants={fadeUpVariants}
              onClick={handleButtonBookConsultation}
            >
              {t("readyToSave.button")}
            </motion.button>
          </motion.div>
        </div>

        <motion.div
          className="hidden lg:block relative min-h-screen overflow-hidden"
          variants={imageVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <img
            src="/assets/Row1.webp"
            alt="Dental patient in chair"
            className="w-full h-full object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default ReadyToSave;
